module.exports = __webpack_public_path__ + "static/media/megaphone.34f479cd.svg";